import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import useSeo from '../../hooks/useSeo';
import Hero from '../../components/sections/Hero';
import DemosGallery from '../../components/sections/DemosGallery';
import Process from '../../components/sections/Process';
import WhatIDo from '../../components/sections/WhatIDo';
import GrowthAutomation from '../../components/sections/GrowthAutomation';
import FeaturedProjects from '../../components/sections/FeaturedProjects';
import About from '../../components/sections/About';
import Contact from '../../components/sections/Contact';

function Home() {
  const [searchParams] = useSearchParams();

  useSeo({
    title: 'Sudco Solutions — AI Automation for Small Business',
    description:
      'Agentic AI for small business — AI agents and digital workers that handle invoicing, collections, marketing outreach, reviews, and bookkeeping. Plus modern websites, $800 flat.',
    path: '/',
  });

  useEffect(() => {
    const from = searchParams.get('from');
    if (!from) return;
    fetch('/api/showcase_views', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ prospect_id: from, demo_slug: 'homepage' }),
      keepalive: true,
    }).catch(() => {});
  }, [searchParams]);

  return (
    <>
      <Hero />
      <DemosGallery />
      <Process />
      <WhatIDo />
      <GrowthAutomation />
      <FeaturedProjects />
      <About />
      <Contact />
    </>
  );
}

export default Home;
